module.exports = __webpack_public_path__ + "img/ron_h_2.914201f8.png";